export default "__VITE_ASSET__bTKKODjq__"